<script>
export default {
    name: "InMorgueReport",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.allSettled([ this.fetchPatientList(), ]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 250);  
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchPatientList() {
            
            let url = `Morgue/GetPatientsInMorgue`;

            return this.$http.get(url).then(response => {
                this.patients = response.data;
            }).catch(() => { });
        },
    }
}
</script>
<template>
    <div class="w-full flex flex-wrap mx-2">
        <table class="table">
            <tbody class="text-sm font-medium flex flex-col 
                items-center overflow-auto w-full">
                <tr class="flex w-full text-base font-bold">
                    <th class="p-tiny w-1/5">Name</th>
                    <th class="p-tiny flex-1">Morgue No</th>
                    <th class="p-tiny flex-1">Package</th>
                    <th class="p-tiny flex-1">Admission Date</th>
                    <th class="p-tiny flex-1">Days</th>
                    <th class="p-tiny flex-1">Bed</th>
                    <th class="p-tiny flex-1">National ID</th>
                    <th class="p-tiny flex-1">Reg NO</th>
                </tr>
                <tr class="flex w-full" v-for="(pat,idx) in patients" :key="idx">
                    <td class="p-tiny w-1/5">
                        <h5 class="text-sm text-gray-900">{{ pat.patient }}</h5>
                        <h5 class="text-sm">MRN: 
                            <span class="text-blue-800">{{ pat.patienT_ID }}</span></h5>
                        <h5 class="text-sm">Gender: 
                            <span class="text-blue-800">{{ pat.gender }}</span></h5>
                        <h5 class="text-sm">DOB: 
                            <span class="text-blue-800">{{ pat.dob | dateFormat }}</span></h5>
                    </td>
                    <td class="p-tiny flex-1">{{ pat.morgueNo }}</td>
                    <td class="p-tiny flex-1">{{ pat.package }}</td>
                    <td class="p-tiny flex-1">{{ pat.date | dateFormat }}</td>
                    <td class="p-tiny flex-1">{{ pat.days }}</td>
                    <td class="p-tiny flex-1">{{ pat.bed }}</td>
                    <td class="p-tiny flex-1">{{ pat.nationalid }}</td>
                    <td class="p-tiny flex-1">
                        <h5 class="text-sm">
                            <span class="font-semibold">IP File No: 
                                </span>{{ pat.ipfileno }}</h5>
                        <h5 class="text-sm">
                            <span class="font-semibold">OP File No: 
                                </span>{{ pat.opfileno }}</h5>
                        <h5 class="text-sm">
                            <span class="font-semibold">Morgue No: </span>
                            {{ pat.morgueNo }}</h5>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>